import { GraphQLClient } from 'graphql-request';
import { create } from "@yornaath/batshit";
import { getEnv } from '../environment/resolve';

// Built lazily so appHost resolves from the browser hostname
// (module scope would freeze it to the SSG/build-time fallback).
const buildClient = () => new GraphQLClient(new URL(`${getEnv().appHost}/gql`), {
  credentials: 'include'
});
const fetcher = ({
  document,
  variables
}) => buildClient().request(document, variables);
export default fetcher;
export const createBatchedFetcher = (maxBatchSize = 1, windowMs = 100, maxWaitTimeMs = 100) => {
  const fetcher = create({
    scheduler: (start, latest, batchSize) => {
      if (batchSize >= maxBatchSize) {
        return "immediate";
      }
      const spent = latest - start;
      return Math.min(windowMs - spent, maxWaitTimeMs);
    },
    fetcher: async queries => {
      const results = await buildClient().batchRequests(queries);
      return queries.map((q, i) => ({
        query: q,
        result: results[i]
      }));
    },
    resolver: (results, query) => {
      const {
        data,
        errors
      } = results.find(r => r.query === query).result;
      if (errors) {
        throw errors;
      }
      return data;
    }
  });
  return fetcher.fetch;
};